import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, lastValueFrom } from 'rxjs';
import { AuthService } from '../auth.service';
import { ROLE_WORKSPACE_USER } from 'src/app/app.models';

@Injectable({
    providedIn: 'root'
})
export class BENoAuthGuard implements CanActivate {
    constructor(
        private _router: Router,
        private _authService: AuthService
    ) {
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const authSessionDto = this._authService.authenticatedSession$.value!;
        if (this._authService.isAuthenticated && !!authSessionDto) {
            if (authSessionDto.ROLE_ID == ROLE_WORKSPACE_USER.SUPER_ADMIN_WORKSPACE || authSessionDto.ROLE_ID == ROLE_WORKSPACE_USER.ADMIN_WORKSPACE) { this._router.navigate(['/cluadmin/apps/p-admin/adm-sites']); return false; }
            else {  await lastValueFrom(this._authService.doRemoveAuthSession()); }
        }

        return true;
    }
}
